var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-4"},[_c('h2',{staticClass:"justify-center"},[_vm._v(_vm._s(_vm.$t('invoices.pay_invoices_title'))+" "+_vm._s(_vm.orderId))])]),_vm._v(" "),_c('p',{staticClass:"mt-2 mb-0 py-0"},[_vm._v("\n        "+_vm._s(_vm.$t('invoices.pay_success_message'))+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }